import { useContext } from 'react';
import { SessionContext } from '@tcs/client-portal-common/providers/SessionProvider';

export const useSession = () => useContext(SessionContext);

export default useSession;
